module.exports = __webpack_public_path__ + "static/media/oneWay.00b00e39.jpg";